import React from 'react';
import PropTypes from 'prop-types';
import { Form, Select } from 'antd';
import { getIn } from 'formik';
const { Option } = Select;

function SelectBox(props) {
  const {
    field,
    form,
    options,
    label,
    mode,
    notFoundContent,
    ...restProps
  } = props;

  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const hasError = error !== undefined && touched;
  const isValid = !error && !!touched;

  const renderOptions = () => {
    return options.map(({ label, value }) => (
      <Option key={value}>{label}</Option>
    ));
  };

  const { name, value } = field;
  return (
    <Form.Item
      validateStatus={hasError ? 'error' : undefined}
      hasFeedback={isValid}
      label={label}
      help={(hasError && <li>{error}</li>) || (isValid && '')}
    >
      <Select
        mode={mode}
        placeholder={label}
        notFoundContent={notFoundContent}
        onChange={val => {
          form.setFieldValue(name, val);
        }}
        value={value}
        {...restProps}
      >
        {renderOptions()}
      </Select>
    </Form.Item>
  );
}
SelectBox.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  options: PropTypes.array,
  label: PropTypes.string,
  defaultValue: PropTypes.array,
  mode: PropTypes.string,
  notFoundContent: PropTypes.string
};
SelectBox.defaultProps = {
  defaultValue: []
};
export default SelectBox;
